// extracted by mini-css-extract-plugin
module.exports = {"content":"SheetContent_content__wDL8r","main":"SheetContent_main__WV_23"};